import React, { Component } from 'react';
import AudioSpectrum from '../AudioSpectrum'
import './styles.css';
import soundFile from '../Musics/BeatTrap.mp3'

// https://medium.com/swlh/create-an-audio-visualizer-with-react-and-canvas-part-1-of-3-da414a1edfed

class Visualizer extends Component {
    // constructor(props) {
    //     super(props);
    //     this.audioElem = new Audio(soundFile);
    // }

    // render() {
    //     return(
    //         <div>
    //             <AudioSpectrum
    //                 id="audio-canvas"
    //                 height={200}
    //                 width={300}
    //                 audioEle={this.audioElem}
    //             />
    //         </div>
    //     );
    // }
    constructor(props) {
        super(props)
        this.audioElem = new Audio(soundFile);
    }

    render() {
        return(
            <div>
                <audio className="audio-element"
                    src={soundFile}
                    autoPlay
                >
                </audio>
                {
                    <AudioSpectrum
                        id="audio-canvas"
                        height={200}
                        width={300}
                        audioId={'audio-element'}
                        capColor={'red'}
                        capHeight={2}
                        meterWidth={2}
                        meterCount={512}
                        meterColor={[
                            {stop: 0, color: '#f00'},
                            {stop: 0.5, color: '#0CD7FD'},
                            {stop: 1, color: 'red'}
                        ]}
                        gap={4}
                    />
                }
            </div>
        );
    }



}

export default Visualizer;


















// import React from 'react';
// // import Canvas from './Canvas';


// import './styles.css';

// const Visualizer = () => {
//     return <>
//     <header className="App-header">
//         {/* <Canvas /> */}
//     </header>
//     </>
// }

// export default Visualizer;